import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/real-rate-of-return',
  component: () => import('../../routes/RealRateOfReturnCalculator.svelte'),
  card: {
    id: 'real-rate-of-return',
    title: 'Real Rate of Return',
    description: 'Calculate your true investment gains by adjusting nominal returns for inflation using the Fisher Equation.',
    icon: 'water_drop',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/real-rate-of-return',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Real Rate of Return Calculator – Inflation-Adjusted Investment Returns',
    description: 'Free real rate of return calculator. Adjust your investment returns for inflation using the Fisher Equation to find your true purchasing power growth.',
  },
};

export default meta;
